/* eslint-disable */
export default {
  noActiveCalls: 'Aucun appel actif',
  currentCall: 'Appel en cours',
  ringCall: 'Sonnerie en cours',
  onHoldCall: 'Appel en attente',
  otherDeviceCall: 'Appels en cours sur mes autres terminaux',
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Ajouter à la conférence téléphonique ?',
  mergeToConference: 'Fusionner',
  conferenceCall: 'Conférence téléphonique',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
